import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {IdynamicFormItem} from '../../../shared/dynamic-form/interfaces/IdynamicFormItem';
import {IWidgetItem} from '../../../../modules/widgets/interfaces/widget-item.interface';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";

@Component({
  selector: 'gen-trial-cohort-information',
  templateUrl: './trial-cohort-drug.component.html',
  styleUrls: ['./trial-cohort-drug.component.scss']
})
@Widget('TrialCohortDrug')
export class TrialCohortDrugComponent implements OnInit, OnDestroy, IWidgetItem {
  public formItems: IdynamicFormItem[] = [];
  public shortFormItems: IdynamicFormItem[];

  private _data: any[] = [];

  widgetUpdateValueCallback: (value) => void;
  private onDestroyCallbacks: Array<Function> = [];

  ngOnDestroy(): void {
  }
  set widgetConfig(widgetConfig: IdynamicFormItem) {
    Object.assign(this, widgetConfig.widgetPayload);
  }

  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  @Input()
  public set data(data: any[]) {
    this._data = data;
  }

  public get amount() {
    return this._data.length;
  }

  public get data() {
    return this._data;
  }


  constructor() {
  }

  ngOnInit() {
    if (!this._data) {
      this._data = [];
    }
  }

  removeDrug(index) {
    this._data.splice(index, 1);
    this.widgetUpdateValueCallback(this._data);
  }

  navigate(url) {
    const fullUrl = url.startsWith('http') ? url : `http://${url}`;
    window.open(fullUrl, '_blank');
  }
}
